__turbopack_context__.v({
  "brandBadge": "_7iMcma_brandBadge",
  "brandBadgeAgency": "_7iMcma_brandBadgeAgency",
  "brandCard": "_7iMcma_brandCard",
  "brandChip": "_7iMcma_brandChip",
  "brandDesc": "_7iMcma_brandDesc",
  "brandGrid": "_7iMcma_brandGrid",
  "brandHeading": "_7iMcma_brandHeading",
  "brandLogo": "_7iMcma_brandLogo",
  "brandMeta": "_7iMcma_brandMeta",
  "brandName": "_7iMcma_brandName",
  "brandTop": "_7iMcma_brandTop",
  "brandYears": "_7iMcma_brandYears",
  "brandsHead": "_7iMcma_brandsHead",
  "brandsLead": "_7iMcma_brandsLead",
  "brandsSection": "_7iMcma_brandsSection",
  "companyLogo": "_7iMcma_companyLogo",
  "companyName": "_7iMcma_companyName",
  "experienceContainer": "_7iMcma_experienceContainer",
  "eyebrow": "_7iMcma_eyebrow",
  "filterBar": "_7iMcma_filterBar",
  "filterChip": "_7iMcma_filterChip",
  "filterChipActive": "_7iMcma_filterChipActive",
  "filterCount": "_7iMcma_filterCount",
  "intro": "_7iMcma_intro",
  "introActions": "_7iMcma_introActions",
  "introLead": "_7iMcma_introLead",
  "introStats": "_7iMcma_introStats",
  "jumpLink": "_7iMcma_jumpLink",
  "pageTitle": "_7iMcma_pageTitle",
  "role": "_7iMcma_role",
  "roleBrands": "_7iMcma_roleBrands",
  "roleBrandsLabel": "_7iMcma_roleBrandsLabel",
  "roleCard": "_7iMcma_roleCard",
  "roleDescription": "_7iMcma_roleDescription",
  "roleHeader": "_7iMcma_roleHeader",
  "rolePeriod": "_7iMcma_rolePeriod",
  "roleTitle": "_7iMcma_roleTitle",
  "sectionHeading": "_7iMcma_sectionHeading",
  "sectionTitle": "_7iMcma_sectionTitle",
  "timeline": "_7iMcma_timeline",
  "viewDetailsLink": "_7iMcma_viewDetailsLink",
});
